import settings from "settings";
import isEmpty from "lodash/isEmpty";
import memoize from "lodash/memoize";
import moment from "moment";
import get from "lodash/get";
import map from "lodash/map";

import { getLocalizationSafe } from "./localization";
import { getSeasonLeagues } from "./seasons";
import { SEASON_TYPES } from "fe2/Reducers/ReducerRatings";
import { TYPE_GLOBAL_SEARCH } from "fe2/Actions/ActionClanRating";


export const getLeagueNameByNumber = (league, season) => {
  const leagues = getSeasonLeagues(season);

  return !isEmpty(leagues) ? getLocalizationSafe(leagues[league], 'mark') : null;
};

export const getLadderLocalPrimeTimeWeekday = memoize((weekday, primeTimeDaysMap) => {
  // TODO: Be aware! Memoize function uses only first argument for cache key.
  // Argument `primeTimeDaysMap` should be removed when season`s prime time days will be stored
  // in right place (not in settings.recommendations.userSettingsMapping.gameDays)

  const utcNowDayStart = moment.utc().startOf('day');

  const primeTimeInfo = primeTimeDaysMap[weekday];
  const minutesToPrimeTimeSinceMidnight = (primeTimeInfo && primeTimeInfo[0] || 0) / 60;

  return utcNowDayStart.minutes(minutesToPrimeTimeSinceMidnight).weekday(weekday).local().weekday();
});


export function getLastSeason(): null | Object {
  const seasons = get(settings, 'ladder.seasons', {});
  const lastSeasonId = get(settings, 'ladder.lastSeasonId', null);
  if (lastSeasonId && seasons[lastSeasonId]) return seasons[lastSeasonId];
  return null;
}


export function getSeasonById(id: number) {
  return get(settings, 'ladder.seasons', {})[id];
}


export const isLastSeasonRegular = () => {
  const season: any = getLastSeason();
  return season && season.kind && season.kind === SEASON_TYPES.REGULAR;
};


export const getLastRegularSeason = () => {
  return getLastSeasonOfType(SEASON_TYPES.REGULAR);
};


export const getLastBrawlSeason = () => {
  return getLastSeasonOfType(SEASON_TYPES.BRAWL);
};

export const getLastSeasonOfType = (seasonType: string) => {
  const seasons = get(settings, 'ladder.seasons', {});
  const now = parseInt(`${Date.now() / 1000}`, 10);
  const lastSeasonId = get(settings, 'ladder.lastSeasonId', null);
  const lastSeasonIgnoreTimeCondition = get(settings, 'ladder.lastSeasonIgnoreTimeCondition', false);

  if (seasons) {
    if (lastSeasonId && seasons[lastSeasonId] && seasons[lastSeasonId].kind === seasonType) {
      return seasons[lastSeasonId];
    } else {
      const sortedFilteredSeasons = map(seasons).filter((season: any) => season.kind === seasonType && (lastSeasonIgnoreTimeCondition || season.start_time < now)).sort((a: any, b: any) => a.id - b.id);
      return sortedFilteredSeasons.pop();
    }
  } else {
    return null;
  }
};


export const isClanBattleType = (battleType: string) => battleType === 'cvc' || battleType === 'brawl';


export const excludedRealms = get(settings, 'excludedRealms', []);
export const isGlobalSearchEnabled = !excludedRealms.includes(TYPE_GLOBAL_SEARCH);